<template lang="pug">
b-navbar.header-upper-navbar
  .empty
  b-nav(:is-navbar="true")
    b-nav-text
      span.cif {{ cif }}
      span.cif -
      span.tradename(v-if="typePerson==='LP'") {{ tradeName }}
      span.tradename(v-else) {{ name }}
      span.tradename -
      span.username {{ username }}
  b-nav.right(:is-navbar="true")
    b-nav-text(v-if="userSubscription === 'PREMIUM'" class="pro-account")
      span {{ $t('menus.topmenu.header.proAccount') }}
    b-nav-text(v-else class="free-account")
      span(@click="showModalFreeAcount") {{ $t('menus.topmenu.header.freeAccount') }}
      b-modal#freeaccount-modal(
        size="lg"
        ref="free-account-modal"
        :title="$t('menus.topmenu.header.proFunctionalities.title')"
        hide-footer)
        div(v-if="doContract === false")
          h4 {{ $t('menus.topmenu.header.proFunctionalities.subtitle') }}
          p {{ $t('menus.topmenu.header.proFunctionalities.func1') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func2') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func3') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func4') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func5') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func6') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func7') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func8') }}
          hr
          p {{ $t('menus.topmenu.header.proFunctionalities.func9') }}
          b-button(variant="primary" @click="doContractPro") {{ $t('menus.topmenu.header.contract') }}
        div(v-else)
          spinner(v-if="doContractLoading === true" class="modal-spinner")
          div(v-else)
            h4 {{ $t('menus.topmenu.header.proFunctionalities.subscription') }}
            p {{ this.doContractMsg }}
            b-button(variant="primary" @click="hideModalFreeAccount") {{ $t('menus.topmenu.header.proFunctionalities.close') }}
    b-nav-item-dropdown(:text="language.name")
      b-dropdown-item(:key="lang.id" v-for="lang in languageOptions")
        a(
        value-field="id"
        text-field="name"
        @click="language = lang.id"
        :data-vv-as="$t('menus.topmenu.header.language')") {{ lang.name }}
    b-nav-item
      a(href='', alt='Sign out' @click="logout")
        i.menuIcon(class="icon-top-menu icon-logout")
</template>

<script>
import spinner from '@/components/shared/Spinner'
import { setCookie } from '@/utils/utils'
import session from '@/auth/session'
import config from '@/utils/config'
import i18n from '@/i18n'
import company from '@/api/apiUsersManagement/services/company'
import { getUserSubscription } from '@/utils/tokenUtils'

export default {
  name: 'header-upper-navbar',
  components: {
    spinner
  },
  data () {
    return {
      doContract: false,
      doContractLoading: true,
      doContractMsg: "",
      userSubscription: getUserSubscription()
    }
  },
  computed: {
    logo: {
      get () {
        return `/static/img/${config.logo}`
      }
    },
    userCifOptions: {
      get() {
        return [
          {
            id: this.$store.state.me.document,
            name: this.$store.state.me.document
          }
        ]
      }
    },
    cif: {
      get () {
        return this.$store.state.me.document
      },
      set (value) {
        this.$store.state.me.document = value
      }
    },
    tradeName: {
      get() {
        return this.$store.state.me.tradeName
      }
    },
    /**
     * @override
     */
    username: () =>
      session.getSecValue('username'),
    languageOptions: {
      get() {
        return [
          {
            id: 'es',
            name: 'ES'
          },
          {
            id: 'en',
            name: 'EN'
          },
          {
            id: 'pt',
            name: 'PT'
          }
        ]
      }
    },
    language: {
      get () {
        return this.languageOptions.find(x => x.id === i18n.locale)
      },
      set (value) {
        i18n.locale = value
      }
    },
    name: {
      get () {
        return this.$store.state.me.name
      }
    },
    typePerson: {
      get () {
        return this.$store.state.me.type
      }
    }
  },
  methods: {
    logout() {
      setCookie(config.jwtCookieName, '', 0) // Borramos la cookie
      session.destroy() // Borramos datos sesión
      this.$router.push('/login')
    },
    showModalFreeAcount() {
      this.$refs['free-account-modal'].show()
    },
    hideModalFreeAccount() {
      this.$refs['free-account-modal'].hide()
    },
    doContractPro() {
      this.doContract = !this.doContract
      let data = {
        "address": this.$store.state.me.address.street,
        "city": this.$store.state.me.address.city,
        "corporateName": this.$store.state.me.name === null ? "null" : this.$store.state.me.name,
        "country": this.$store.state.me.address.country,
        "email": this.$store.state.me.contactMedium.email === null ? "null" : this.$store.state.me.contactMedium.email,
        "nif": this.$store.state.me.document === null ? "null" : this.$store.state.me.document,
        "phone": this.$store.state.me.contactMedium.telephone === null ? "999999999" : this.$store.state.me.contactMedium.telephone,
        "postalCode": this.$store.state.me.address.postalCode,
        "region": this.$store.state.me.address.town,
        "subscription": this.userSubscription === null ? "null" : this.userSubscription
      }
      company.subscription(data, config.promoterCode)
        .then((res) => {
          this.doContractMsg = this.$t('menus.topmenu.header.proFunctionalities.success')
          this.doContractLoading = false
        })
        .catch(error => {
          this.doContractMsg = `${this.$t('menus.topmenu.header.proFunctionalities.error')} ${config.supportEmail}`
          this.doContractLoading = false
          console.log(error)
        })
      }
    },
  mounted () {
    Promise.all([
      this.$store.dispatch('me/get')
    ]).then((result) => {})
    this.$ga.set('userId', this.$store.state.me.document)
  }
}
</script>
